import { z } from "zod";

/** Keyset-paginated collection (modules-and-api.md §0.4, §2.11). Offsets are never used. */
export interface Page<T> {
  items: T[];
  /** Opaque keyset cursor. Absent on the last page. */
  nextCursor?: string;
  /** Present only when the caller passed ?count=true. */
  totalCount?: number;
}

export const ListQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(200).default(50),
  cursor: z.string().max(512).optional(),
  count: z.enum(["true", "false"]).optional(),
  sort: z.string().max(64).optional(),
  branchId: z.string().max(32).optional(),
});
export type ListQuery = z.infer<typeof ListQuerySchema>;

export function pageOf<T>(items: T[], nextCursor?: string, totalCount?: number): Page<T> {
  const p: Page<T> = { items };
  if (nextCursor !== undefined) p.nextCursor = nextCursor;
  if (totalCount !== undefined) p.totalCount = totalCount;
  return p;
}
